import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    chips: {
      borderRadius: "4px",
      border: `1px solid ${theme.gray200}`,
      background: theme.gray50,
      padding: theme.spacing(4),
      display: "block",
      cursor: "pointer",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
    },
    objectsCount: {
      width: 20,
      height: 20,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "4px",
      color: theme.white00,
      backgroundColor: theme.primary700,
      marginLeft: theme.spacing(2),
      fontSize: 14,
      lineHeight: 1,
    },
    wrapper: {
      display: "flex",
      alignItems: "center",
    },
    icon: {
      marginRight: theme.spacing(4),
      transition: "0.3s",
    },
    rotate: {
      transform: "rotate(180deg)",
    },
    attrChild: {
      marginLeft: theme.spacing(8),
      marginTop: 0,
      textAlign: "center",
    },
    content: {
      display: "flex",
      alignItems: "center",
      marginBottom: theme.spacing(4),
      maxWidth: "100%",
      overflow: "hidden",
    },
    showMoreBtn: {
      fontSize: "13px",
      textDecoration: "underline",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    attributesContainerModal: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(4),
      flexWrap: "nowrap",
      overflowX: "hidden",
    },
    hiddenTooltip: {
      display: "none",
    },
  }),
);
